const If = <C>({ condition, children }: { condition: C; children: any }): any => condition ? children : null;

export default If;
